import { create } from "zustand";
import { devtools } from "zustand/middleware";

import { URL_SEARCH_PARAMS } from "@/constants/urlSearchParams";

import { STATUSES } from "./ContractorSelect.constants";
import { TContractorSelectState, TContractorSelectStore, TContractorsStatus } from "./ContractorSelect.types";

const initialContractorSelectState: TContractorSelectState = {
  contractorId: new URLSearchParams(location.search).get(URL_SEARCH_PARAMS.CONTRACTOR_ID) ?? "",
  status: STATUSES.AWAITING,
};

export const useContractorSelectStore = create<TContractorSelectStore>()(
  devtools(set => ({
    ...initialContractorSelectState,
    setContractorId: (contractorId: string) => {
      set({
        contractorId,
      });
    }, setStatus: (status: TContractorsStatus) => {
      set({
        status,
      });
    },
  })),
);
